import { render, staticRenderFns } from "./OrderView.vue?vue&type=template&id=888d41f0&scoped=true"
import script from "./OrderView.vue?vue&type=script&lang=js"
export * from "./OrderView.vue?vue&type=script&lang=js"
import style0 from "./OrderView.vue?vue&type=style&index=0&id=888d41f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888d41f0",
  null
  
)

export default component.exports